import { Css } from "@homebound/beam";
import { ObjectState } from "@homebound/form-state";
import { fail, queryResult } from "src/utils";
import { PlanBasedBidPackageFormState } from "../utils";
import { usePlanBasedBidPackageReviewAndDownloadStepQuery } from "./3.ReviewAndDownloadStep.generated";
import { PlanBasedBidsTableV2 } from "./PlanBasedBidsTableV2";

type ReviewAndDownloadStepProps = { formState: ObjectState<PlanBasedBidPackageFormState> };

export function ReviewAndDownloadStep(props: ReviewAndDownloadStepProps) {
  const query = usePlanBasedBidPackageReviewAndDownloadStepQuery({
    variables: { bidPackageId: props.formState.bidPackageId.value ?? fail("bidPackageId is required") },
  });
  return (
    <div css={Css.df.fdc.$}>
      <div css={Css.df.fdc.aic.my6.$}>
        <div css={Css.xl2.$}>Review and Download</div>
      </div>
      {queryResult(query, ({ bidPackage }) => (
        <PlanBasedBidsTableV2 bidPackage={bidPackage} />
      ))}
    </div>
  );
}
